import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { oauthService } from "./oauthService";

/**
 * Login Page - простая страница с кнопкой OAuth
 *
 * KISS: Если уже залогинен - редирект на главную
 */
export const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Проверяем токен и ошибки OAuth
  useEffect(() => {
    // Проверяем если уже залогинен
    if (localStorage.getItem("token")) {
      setIsAuthenticated(true);
      return;
    }

    // Проверяем ошибки OAuth в URL
    const params = new URLSearchParams(window.location.search);
    const errorParam = params.get("error");
    if (errorParam) {
      setError(params.get("error_description") || errorParam);
      window.history.replaceState({}, "", "/login");
    }

    // Check for auth=required param (from magic link OAuth flow)
    // Auto-start OAuth when redirected from auth service after magic link
    const authRequired = params.get("auth");
    if (authRequired === "required") {
      window.history.replaceState({}, "", "/login");
      oauthService.startLogin();
    }
  }, []);

  // Редирект если залогинен
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      await oauthService.startLogin();
    } catch (err: any) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <Card sx={{ maxWidth: 400, width: "100%", mx: 2 }}>
        <CardContent sx={{ p: 4, textAlign: "center" }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              bgcolor: "primary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <LockIcon sx={{ fontSize: 32, color: "white" }} />
          </Box>

          <Typography variant="h5" gutterBottom>
            SmarChat Admin
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Войдите через INITE Auth для доступа к панели управления
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              "Войти через INITE Auth"
            )}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};
